export default {"src":"/_next/static/image/public/images/ic_apple_pay.fc28a041024672f0749ad220bd0162d4.svg","height":17,"width":42};